import { type UNSAFE_any } from '@flecto/types'

import { type FilterValue } from '../components/multi-select/filterTypeConfig'

export const flattenFilters = (
  filters: FilterValue[]
): Record<string, UNSAFE_any> => {
  return filters.reduce(
    (acc, curr) => {
      acc[curr.key] = curr.value
      return acc
    },
    {} as Record<string, UNSAFE_any>
  )
}
